import { useStyles } from '../styles';
import Button from '@material-ui/core/Button';
import ChannelsFormDetails from './shared/ChannelsFormDetails';
import ChannelsUserDetails from './shared/ChannelsUserDetails';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import React, { useEffect, useState } from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import _ from 'lodash';
import useCustomUserSelected from '../../../Hooks/useCustomUserSelected';
interface IChannelsModifyFormProps {
    activeEvent: 'string';
    updateChannel: Function;
    users: any[];
    initialData: {
        name: string;
        imageURL: string;
        isNameHidden: boolean|undefined;
        whitelist: any[];
    };
    madeWhitelist: any[];
    fetchUsersFromGroup: any;
}

function ChannelsModifyForm({ initialData, madeWhitelist, updateChannel, users }: IChannelsModifyFormProps) {
    const [nameField, setNameField] = useState('');
    const [isNameHidden, setIsNameHidden] = useState(false);
    const [imageURL, setImageURL] = useState('');
    const [fileSelected, setFileSelected] = useState(false);
    const [nameEmpty, setNameEmpty] = useState(false);
    const classes = useStyles();

    //Feeds in Searchable users and groups and madeWhitelist is passed in for initially selected rows
    const userSelectionHook = useCustomUserSelected([], madeWhitelist);
    const [privateMode, setPrivateMode] = useState(madeWhitelist.length > 0 ? true : false);
    interface IWhitelist {
        [key: string]: any;
    }

    const [value, setValue] = React.useState(0);
    useEffect(() => {
        //_.unionBy allows us to create selectableUsers list with pre-selected rows based off of the madeWhitelist array
        userSelectionHook.setUsers(_.unionBy(madeWhitelist, users, 'id'));
    }, [users]);
    useEffect(() => {
        setNameField(initialData.name);
        setImageURL(initialData.imageURL);
        setIsNameHidden(initialData.isNameHidden ? initialData.isNameHidden : false)
    }, [initialData.name, initialData.imageURL, initialData.isNameHidden]); //Re-visit from performance standpoing

    const handleNameChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = evt.target;
        setNameField(value);
    };

    const handleIsNameHiddenChange = (evt: any) => {
        const { checked } = evt.target
        setIsNameHidden(checked);
    };

    const handleFileChange = async (res: any) => {
        setImageURL(res);
        setFileSelected(true); //Used in the saga to determine whether to sync filestorage or not
    };

    function handleChange(event: any, newValue: any) {
        if (nameField === '') {
            setNameEmpty(true);
            return false;
        }
        setValue(newValue);
    }

    const handleSaveChannel = () => {
        updateChannel({
            fileSelected,
            imageURL,
            isNameHidden,
            name: nameField,
            whitelist: userSelectionHook.checked,
        });
    };

    return (
        <React.Fragment>
            <Paper className={classes.paper}>
                <Tabs
                    centered
                    className={classes.tabs}
                    indicatorColor="primary"
                    onChange={handleChange}
                    textColor="primary"
                    value={value}
                >
                    <Tab label="Details" />
                    <Tab label="Users" />
                </Tabs>

                {value === 0 && (
                    <ChannelsFormDetails
                        handleFileChange={handleFileChange}
                        handleNameChange={handleNameChange}
                        imageURL={imageURL}
                        nameEmpty={nameEmpty}
                        nameField={nameField}
                        isNameHidden={isNameHidden}
                        handleIsNameHiddenChange={handleIsNameHiddenChange}
                    />
                )}

                {value === 1 && (
                    <ChannelsUserDetails
                        privateMode={privateMode}
                        setPrivateMode={setPrivateMode}
                        userSelectionHook={userSelectionHook}
                    />
                )}
                <Container style={{ paddingTop: '25px' }}>
                    <Button color="primary" onClick={handleSaveChannel} variant="contained">
                        Save
                    </Button>
                </Container>
            </Paper>
        </React.Fragment>
    );
}

export default ChannelsModifyForm;
